import store from "store";
// import UserApi from "../api/UserApi";

const KEY_TOKEN = "token";
const KEY_ACCESS = "access";
const KEY_ACCOUNT_INFO = "accountInfo";
const KEY_SERVICE_TYPE = "serviceType";
const KEY_CURRENT_ORG = "currOrgId";
const KEY_FLAG_TYPE = "flagType";
const KEY_RTE = "rte";
const KET_MODE = "mode";
const ENUMERATION_LIST = "enumerationList"
const KEY_ABID = "abId";
const PROJECT_TYPE = 'projectType'
const KEY_ORGID = 'orgId'
const SourceId = 'sourceId'
const KEY_MENU_INDEX = 'menuIndex'
const KEY_PERSON_SETTING = 'person-setting'
const KEY_FINANCE_SETTING = 'finance-setting'

export default {
  cachedToken: null,
  baseInfoCache: null,
  serviceType: null,
  currOrgId: null,
  flagType: null,
  rte: null,
  mode: null,

  saveToken(token) {
    // this.cachedToken = token;
    sessionStorage[KEY_TOKEN] = token;
  },
  saveAbid(data) {
    localStorage[KEY_ABID] = data
    sessionStorage[KEY_ABID] = data;

  },
  getAbid() {
    return sessionStorage[KEY_ABID]

  },
  getToken() {
    // if (this.cachedToken)
    //   return this.cachedToken;
    return sessionStorage[KEY_TOKEN];
  },
  saveSourceId(sourceId){
    sessionStorage[SourceId] = sourceId;
  },
  getSourceId(){
    return sessionStorage[SourceId];
  },
  saveProjectType(project) {
    sessionStorage[PROJECT_TYPE] = project
  },
  getProjectType() {
    return sessionStorage[PROJECT_TYPE]
  },

  saveServiceType(type) {
    this.serviceType = type;
    sessionStorage[KEY_SERVICE_TYPE] = type;
  },
  saveCurrOrgId(id) {
    this.currOrgId = id;
    sessionStorage[KEY_CURRENT_ORG] = id;
  },
  getServiceType() {
    if (this.serviceType)
      return this.serviceType;
    return sessionStorage[KEY_SERVICE_TYPE];
  },
  getCurrOrgId() {
    if (this.currOrgId)
      return this.currOrgId;
    return sessionStorage[KEY_CURRENT_ORG];
  },
  saveFlagType(type) {
    this.flagType = type;
    sessionStorage[KEY_FLAG_TYPE] = type;
  },
  getFlagType() {
    if (this.flagType)
      return this.flagType;
    return sessionStorage[KEY_FLAG_TYPE];
  },
  saveRte(type) {
    this.rte = type;
    sessionStorage[KEY_RTE] = JSON.stringify(type);
  },
  saveOrgId(id) {
    let baseInfo = this.getBaseInfo();
    baseInfo.orgId = id;
    this.saveBaseInfo(baseInfo)
  },
  getOrgId() {
    return this.getBaseInfo().orgId;
  },
  saveOrganizationId(id) {
    let baseInfo = this.getBaseInfo();
    baseInfo.organizationId = id;
    this.saveBaseInfo(baseInfo)
  },
  getOrganizationId() {
    return this.getBaseInfo().organizationId;
  },
  getRte() {
    if (!this.rte) {
      let rteStr = sessionStorage[KEY_RTE];
      if (rteStr) {
        this.rte = JSON.parse(rteStr);
      } else {
        this.rte = {};
      }
    }
    return this.rte;
  },
  saveAppMode(type) {
    this.mode = type;
    sessionStorage[KET_MODE] = type;
  },
  getAppMode() {
    if (this.mode)
      return this.mode;
    return sessionStorage[KET_MODE];
  },


  saveBaseInfo(accountInfo) {

    let currOrg = accountInfo.currOrg;
    if (!currOrg || typeof currOrg !== 'object') {
      accountInfo.currOrg = {};
    }
    let user = accountInfo.user;
    if (!user || typeof user !== 'object') {
      accountInfo.user = {};
    }
    this.baseInfoCache = accountInfo;
    sessionStorage[KEY_ACCOUNT_INFO] = JSON.stringify(accountInfo);
  },

  getBaseInfo() {
    if (!this.baseInfoCache) {
      let accountStr = sessionStorage[KEY_ACCOUNT_INFO];
      if (accountStr) {
        this.baseInfoCache = JSON.parse(accountStr);
      } else {
        this.baseInfoCache = {}
      }
    }
    return this.baseInfoCache;
  },

  saveAccess(access) {
    sessionStorage[KEY_ACCESS] = access;
  },

  getAccess() {
    return sessionStorage[KEY_ACCESS];
  },
  saveEnumerationList(list) {
    sessionStorage[ENUMERATION_LIST] = list
  },
  getEnumerationList() {
    return JSON.parse(sessionStorage[ENUMERATION_LIST])
  },
  saveMenuIndex(data) {

    sessionStorage[KEY_MENU_INDEX] = JSON.stringify(data)

  },
  //资产管理保存个性化设置
  savePersonnalSetting(data) {
    sessionStorage[KEY_PERSON_SETTING] = JSON.stringify(data)
  },
  getPersonnalSetting() {
    return JSON.parse(sessionStorage[KEY_PERSON_SETTING] || '{}')
  },
  // 会计核算个性化设置
  saveFinanceSetting(data){
    sessionStorage[KEY_FINANCE_SETTING] = JSON.stringify(data);
  },
  getFinanceSetting(){
    return JSON.parse(sessionStorage[KEY_FINANCE_SETTING] || '{}')
  },
  getMenuIndex() {
    return JSON.parse(sessionStorage[KEY_MENU_INDEX] || '{}')
  },
  saveaccountingStandards(data){
    sessionStorage['accountingStandards'] = data;
  },
  getaccountingStandards(){
    return sessionStorage['accountingStandards']
  },

  clear() {
    sessionStorage[KEY_TOKEN] = "";
    sessionStorage[KEY_ACCOUNT_INFO] = "";
    sessionStorage[KEY_ACCESS] = "";
    sessionStorage[KEY_ABID] = ""
    this.cachedToken = '';
    this.baseInfoCache = '';
    this.serviceType = '';
    this.currOrgId = '';
    sessionStorage[KEY_CURRENT_ORG] = '';
    sessionStorage[ENUMERATION_LIST] = '';
    sessionStorage[KEY_ORGID] = '';
    sessionStorage[KEY_MENU_INDEX] = '';
    sessionStorage[KEY_PERSON_SETTING] = '';
    sessionStorage[KEY_ABID] = '';
    sessionStorage[PROJECT_TYPE] = '';
    sessionStorage[SourceId] = '';
    sessionStorage[ENUMERATION_LIST] = '';
    sessionStorage[ENUMERATION_LIST] = '';
    sessionStorage[ENUMERATION_LIST] = '';
    sessionStorage['accountingStandards'] = '';
    sessionStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/persistence/UserPersistence.js